/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  validColor,
  invalidColor,
  noDataColor,
} from '../../utils/styleConst';
import { getAvailableSubscriptionPlacesDisplay, isParamActive } from '../../service/availablesPlacesData';

const ListStyle = styled.ul`
    color: #333;
    font-size: 13px;
    background-color: white;
    font-weight: 400;
    line-height: 1.4;

    li {

      :first-letter {
        text-transform:capitalize;
      }

      :first-child {
        font-size: 14px;
        font-weight: 500;
      }

      &.capacity {
        font-weight: 500;
        color: ${props => (props.free > 0 ? validColor : invalidColor)};

        &.no-data {
          color: ${noDataColor}
        }
      }

      &.capacity-live {
        font-weight: 500;
        color: ${props => (!props.isNotBoxStatus ? (props.freeLive > 0 ? validColor : invalidColor) : noDataColor)};

        &.no-data {
          color: ${noDataColor}
        }
      }

      a {
        color: #427fed;
        text-decoration: none;

        &:hover, &:focus, &:active {
          text-decoration: underline;
        }
      }

    }
`;

const List = ({ studio }) => {
  const isFreeSubscription = studio.remainingSubscriptions !== 0;
  const isFreeLive = studio.liveAvailablePlaces > 0;
  const isNotBoxStatus = studio.liveAvailablePlaces === -1;

  return (
    <ListStyle free={isFreeSubscription} freeLive={isFreeLive} isNotBoxStatus={isNotBoxStatus}>
      <li>{studio.name}</li>
      <li>{studio.streetAddress}, {studio.postalCode} {studio.addressLocality}</li>
      <li>Abri de {studio.capacity} places</li>
      {isParamActive('availablesPlaces') && isFreeLive && (
        <li className="capacity-live">{getAvailableSubscriptionPlacesDisplay(studio)}</li>
      )}
      {isParamActive('availablesPlaces') && !isFreeLive && !isNotBoxStatus && (
        <li className="capacity-live">Aucune place restante</li>
      )}
      {isParamActive('availablesPlaces') && !isFreeLive && isNotBoxStatus && (
        <li className="capacity-live">Aucune information disponible</li>
      )}
      {isParamActive('remainingSubscriptions') && isFreeSubscription && (
        <li className="capacity">{getAvailableSubscriptionPlacesDisplay(studio)}</li>
      )}
      {isParamActive('remainingSubscriptions') && !isFreeSubscription && (
        <li className="capacity">Aucune place restante</li>
      )}
      <li><a target="_blank" href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(studio.streetAddress)},+${encodeURIComponent(studio.addressLocality)}`}>Voir dans Google Maps</a></li>
    </ListStyle>
  );
};

List.propTypes = {
  studio: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};
export default List;




// WEBPACK FOOTER //
// src/components/googleMap/List.jsx